<template>
  <div
    class="top-sub-a flex flex-col align-middle content-center"
    :class="[justify]"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "TopSubA",
  props: {
    justify: {
      type: String,
      default: "justify-center"
    }
  }
};
</script>

<style lang="scss" scoped>
.top-sub-a {
  height: 3.696rem;
  flex: 0 0 3.696rem;
}
@media (min-width: 768px) {
  .top-sub-a {
    height: 4.224rem;
    flex: 0 0 4.224rem;
  }
}
@media (max-width: 380px) {
  .top-sub-a {
    height: 4.224rem;
    flex: 0 0 4.224rem;
    line-height: 1.1;
  }
}
</style>
